// client/src/components/ShortLink.jsx

import React, { useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { collection, getDocs, query, where, limit } from 'firebase/firestore';
import { firestore } from '../../firebase';
import { ensureUserSession } from '../../utils/ensureUserSession';
import ScreenState from '../shared/ScreenState';

// Force le format attendu: digits + spécial + [lower] + [UPPER]
// Si on reçoit "971@Pc", ça renvoie "971@pC"
function canonicalizeShortId(code) {
  const m = /^(\d+)([!@#%&*?])([A-Za-z])([A-Za-z])$/.exec(code || "");
  if (!m) return code;
  const [, digits, special, a, b] = m;
  return `${digits}${special}${a.toLowerCase()}${b.toUpperCase()}`;
}

const ShortLink = () => {
  const { shortId: paramShort } = useParams();
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      let code = paramShort || "";

      // Fallback 1: segment de chemin
      if (!code) {
        const path = decodeURIComponent(pathname || "");
        if (path.startsWith("/")) code = path.slice(1);
      }

      // Fallback 2: ?c=...
      if (!code) {
        const params = new URLSearchParams(search || "");
        const c = params.get("c");
        if (c) code = c;
      }

      // Fallback 3: #xxxxx
      if (!code) {
        const h = decodeURIComponent((hash || "").replace(/^#/, ""));
        if (h) code = h;
      }

      // ✅ Corrige la casse "Pc" -> "pC" et réécrit l'URL sans recharger
      const canonical = canonicalizeShortId(code);
      if (canonical && canonical !== code) {
        window.history.replaceState(null, "", `/${canonical}`);
      }
      const finalCode = canonical || code;

      try {
        // La règle Firestore fidelity exige isSignedIn() → on s'assure d'avoir une session
        await ensureUserSession({ allowNewAnonymous: true, overrideLogoutGuard: true });

        const qRef = query(
          collection(firestore, "fidelity"),
          where("ShortID", "==", finalCode),
          limit(1)
        );
        const snap = await getDocs(qRef);
        if (snap.empty) {
          // 🔴 Redirige vers la vraie 404
          navigate("/404", { replace: true });
          return;
        }
        const merchantUid = snap.docs[0].id;
        navigate(`/redirectqrc/${encodeURIComponent(merchantUid)}`, { replace: true });
      } catch (e) {
        console.error("ShortLink resolve error:", e);
        // 🔴 Erreur → 404 aussi
        navigate("/404", { replace: true });
      }
    })();
  }, [paramShort, pathname, search, hash, navigate]);

  return <ScreenState title="Ouverture de la page commerçant" text="Un instant…" />;
};

export default ShortLink;
